import React from 'react'
import './carousel.css'


function Carousel() {
  return (
    <>
     <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
       <div className='d-flex justify-content-evenly'>
        <div>
            <h1 className='my-3'>50% OFF <br></br>FOR YOUR FIRST <br></br>SHOOPING</h1>
           <h4 className="lead my-2">If you buy something Jessica gives a oppourtinuty to makes a collection</h4>
           <button type="button" class="btns px-3 my-3">Visit Collection</button>
        </div>
      <img src='https://i.ibb.co/gtgJ5Nm/images-2-removebg-preview.png' className="d-block " alt="..."/>
    </div></div>
    <div className="carousel-item">
    <div className='d-flex justify-content-evenly'>
    <div>
            <h1 className='my-3'>50% OFF <br></br>FOR YOUR FIRST <br></br>SHOOPING</h1>
           <h4 className="lead my-2">If you buy something Jessica gives a oppourtinuty to makes a collection</h4>
           <button type="button" class="btns px-3 my-3">Visit Collection</button>
        </div>
      <img src="https://i.ibb.co/gtgJ5Nm/images-2-removebg-preview.png" className="d-block " alt="..."/>
    </div></div>
    <div className="carousel-item">
    <div className='d-flex justify-content-evenly'>
    <div>
            <h1 className='my-3'>50% OFF <br></br>FOR YOUR FIRST <br></br>SHOOPING</h1>
           <h4 className="lead my-2">If you buy something Jessica gives a oppourtinuty to makes a collection</h4>
           <button type="button" class="btns px-3 my-3">Visit Collection</button>
        </div>
      <img src="https://i.ibb.co/LZ0JPTm/images-removebg-preview.png" className="d-block " alt="..."/>
    </div></div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div> 
     

    </>
  )
}

export default Carousel